import type {IScheduledEvent} from "~/data/events";
import moment from "moment-timezone";
import {EVENT_DATE_FORMAT} from "~/data/events";

export function useEventDateLeft(event: IScheduledEvent) {
    const nowDate = ref(moment());
    const endDate = ref(moment(event.dateEnd, EVENT_DATE_FORMAT));
    const startDate = ref(moment(event.dateStart, EVENT_DATE_FORMAT));
    let timeout: any = 0;
    onMounted(() => {
        timeout = setInterval(() => {
            nowDate.value = moment();
        }, 5000);
    })
    onUnmounted(() => clearInterval(timeout));

    const isOnline = computed(() => {
        return startDate.value.isSameOrBefore(nowDate.value) && endDate.value.isSameOrAfter(nowDate.value)
    });
    const leftDays = computed(() => {
        const now = nowDate.value.clone().startOf("day");
        const evDate = startDate.value.clone().startOf("day");
        const left = evDate.diff(now, 'days');
        return Math.max(-1, left);
    });
    const leftHours = computed(() => {
        const left = startDate.value.diff(nowDate.value, 'hours');
        return Math.max(-1, left);
    });
    const leftMinutes = computed(() => {
        const left = startDate.value.diff(nowDate.value, 'minutes');
        return Math.max(-1, left);
    })

    const leftDaysText = computed(() => {
        if(leftDays.value > 5 || leftDays.value < 0) {
            return "";
        }

        if(isOnline.value) return "онлайн";
        if(leftMinutes.value < 0) return "";

        if([3,2].includes(leftHours.value)) return `через ${leftHours.value} часа`;
        if([1].includes(leftHours.value)) return `через час`;
        if(leftDays.value === 0 && leftHours.value === 0) return "совсем скоро";
        if(leftDays.value === 0) return "уже сегодня";
        if(leftDays.value === 1) return "завтра";
        if(leftDays.value === 2) return "послезавтра";
        if([3,4].includes(leftDays.value)) return `через ${leftDays.value} дня`;
        if([1].includes(leftDays.value)) return `через ${leftDays.value} дней`;
    })

    return {
        leftDays,
        leftHours,
        leftMinutes,
        isOnline,
        leftDaysText,
    }
}